module.exports = __webpack_public_path__ + "img/back.334f2116.svg";